import { GraphQLResult } from "@aws-amplify/api-graphql";
import { generateClient } from "aws-amplify/api";
import { ConsoleLogger } from "aws-amplify/utils";
import {
	CreateIDMSLogRecordV1Input,
	ListIDMSLogRecordV1sQuery,
	ModelIDMSLogRecordV1FilterInput,
	SearchableIDMSLogRecordV1FilterInput,
	SearchableIDMSLogRecordV1SortInput,
	SearchIDMSLogRecordV1sQuery,
	SearchIDMSLogRecordV1sQueryVariables,
} from "./API";
import * as mutations from "./graphql/mutations";
import * as queries from "./graphql/queries";
const client = generateClient();
export default class EventService {
	private static LOG = new ConsoleLogger("app", "DEBUG");

	private constructor() {}

	static async auditLog(
		action: string,
		objectId: string,
		oldMessage: any,
		...message: any[]
	) {
		const logRecord = {
			level: "audit",
			action,
			objectId,
			oldMessage: JSON.stringify(oldMessage),
			message: JSON.stringify(message),
			updatedBy: localStorage.getItem("userName"),
			//   eventTimeEpoch: Math.floor(new Date().getTime() / 1000 / 60),
		} as CreateIDMSLogRecordV1Input;
		client.graphql({
			query: mutations.createIDMSLogRecordV1,
			variables: {
				input: logRecord,
			},
		});
	}

	static async log(
		level: "info" | "debug" | "warn" | "error",
		...message: any[]
	) {
		switch (level) {
			case "info":
				this.LOG.info(message);
				break;
			case "debug":
				this.LOG.debug(message);
				break;
			case "warn":
				this.LOG.warn(message);
				break;
			case "error":
				this.LOG.error(message);
				const logRecord = {
					level: "error",
					message: JSON.stringify(message),
					updatedBy: localStorage.getItem("userName"),
					eventTimeEpoch: Math.floor(new Date().getTime() / 1000 / 60),
				} as CreateIDMSLogRecordV1Input;
				client.graphql({
					query: mutations.createIDMSLogRecordV1,
					variables: {
						input: logRecord,
					},
				});
				break;
		}
	}

	static async listLogRecordV1s(filter: ModelIDMSLogRecordV1FilterInput) {
		return (await client.graphql({
			query: queries.listIDMSLogRecordV1s,
			variables: { filter },
		})) as GraphQLResult<ListIDMSLogRecordV1sQuery>;
	}

	static async searchIdmsLogRecordV1s(
		pageSize?: number,
		filter?: SearchableIDMSLogRecordV1FilterInput,
		sort?: SearchableIDMSLogRecordV1SortInput,
		nextToken?: string
	) {
		const qVars: SearchIDMSLogRecordV1sQueryVariables = {
			//   sort,
			filter,
			limit: pageSize || 1000,
			nextToken,
		};
		return (await client.graphql({
			query: queries.searchIDMSLogRecordV1s,
			variables: qVars,
		})) as GraphQLResult<SearchIDMSLogRecordV1sQuery>;
	}
}
